import { jsx as _jsx } from "react/jsx-runtime";
import { ArrowDropDown as ArrowDropDownIcon } from "@mui/icons-material";
import { ArrowRight as ArrowRightIcon } from "@mui/icons-material";
import { Box } from "@mui/material";
export const CollapseIcon = ({ isCollapsed, color = "primary", }) => {
    return (_jsx(Box, { height: "1.5rem", width: "1.5rem", children: isCollapsed ? (_jsx(ArrowRightIcon, { color: color })) : (_jsx(ArrowDropDownIcon, { color: color })) }));
};
//# sourceMappingURL=CollapseIcon.js.map